import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Services.css';

const Services = () => {
  const navigate = useNavigate();
  const [selectedService, setSelectedService] = useState(null);
  const [activeCategory, setActiveCategory] = useState('todos');

  // Datos de los servicios
  const services = [
    {
      id: 1,
      category: 'tech',
      icon: '🚀',
      title: 'Transformación Digital',
      shortDesc: 'Modernizamos tus procesos empresariales con tecnologías de última generación.',
      fullDesc: 'Ayudamos a las empresas a evolucionar digitalmente mediante la implementación de tecnologías avanzadas, automatización de procesos y optimización de flujos de trabajo para mejorar la eficiencia operacional.',
      features: [
        'Análisis de procesos actuales',
        'Diseño de arquitectura digital',
        'Implementación de soluciones',
        'Capacitación del personal',
        'Soporte post-implementación'
      ],
      benefits: [
        'Reducción de costos operativos',
        'Mejora en productividad',
        'Mayor competitividad',
        'Escalabilidad empresarial'
      ],
      duration: '3-6 meses',
    },
    {
      id: 2,
      category: 'tech',
      icon: '🧠',
      title: 'Inteligencia Artificial',
      shortDesc: 'Implementamos soluciones de AI que analizan datos y predicen tendencias.',
      fullDesc: 'Desarrollamos e implementamos soluciones de inteligencia artificial personalizadas que automatizan decisiones complejas, analizan grandes volúmenes de datos y proporcionan insights predictivos para tu negocio.',
      features: [
        'Machine Learning personalizado',
        'Análisis predictivo',
        'Automatización inteligente',
        'Chatbots y asistentes virtuales',
        'Visión por computadora'
      ],
      benefits: [
        'Decisiones basadas en datos',
        'Automatización de tareas repetitivas',
        'Predicción de tendencias',
        'Mejora en experiencia del cliente'
      ],
      duration: '4-8 meses',
    },
    {
      id: 3,
      category: 'tech',
      icon: '☁️',
      title: 'Cloud Computing',
      shortDesc: 'Migración segura a la nube con arquitecturas escalables y eficientes.',
      fullDesc: 'Facilitamos la migración completa o híbrida a la nube, diseñando arquitecturas escalables que reducen costos operativos y mejoran el acceso global a tus sistemas empresariales.',
      features: [
        'Migración completa a la nube',
        'Arquitecturas híbridas',
        'Optimización de costos',
        'Backup y recuperación',
        'Monitoreo 24/7'
      ],
      benefits: [
        'Reducción de costos de infraestructura',
        'Acceso global a sistemas',
        'Escalabilidad automática',
        'Mayor seguridad y respaldos'
      ],
      duration: '2-4 meses',
    },
    {
      id: 4,
      category: 'tech',
      icon: '🔒',
      title: 'Ciberseguridad',
      shortDesc: 'Protección integral contra amenazas digitales con monitoreo 24/7.',
      fullDesc: 'Implementamos sistemas de seguridad robustos que protegen tu infraestructura digital contra amenazas cibernéticas, con monitoreo continuo y planes de respuesta ante incidentes.',
      features: [
        'Auditorías de seguridad',
        'Implementación de firewalls',
        'Monitoreo de amenazas',
        'Planes de respuesta a incidentes',
        'Capacitación en seguridad'
      ],
      benefits: [
        'Protección de datos sensibles',
        'Cumplimiento normativo',
        'Reducción de riesgos',
        'Confianza del cliente'
      ],
      duration: '1-3 meses',
    },
    {
      id: 5,
      category: 'consulting',
      icon: '📈',
      title: 'Gestión Estratégica',
      shortDesc: 'Modelos de gestión orientados a proporcionar ventaja competitiva.',
      fullDesc: 'Desarrollamos e implementamos modelos de gestión estratégica enfocados en tecnologías de la información y comunicaciones para que tu empresa obtenga una verdadera ventaja competitiva en el mercado.',
      features: [
        'Análisis estratégico empresarial',
        'Definición de objetivos TIC',
        'Implementación de metodologías',
        'Indicadores de desempeño',
        'Seguimiento y optimización'
      ],
      benefits: [
        'Ventaja competitiva sostenible',
        'Optimización de recursos',
        'Mejora en toma de decisiones',
        'Alineación estratégica'
      ],
      duration: '2-6 meses',
    },
    {
      id: 6,
      category: 'consulting',
      icon: '⚙️',
      title: 'Implementación de Sistemas de Gestión',
      shortDesc: 'Eficiencia organizacional a través de las mejores prácticas internacionales.',
      fullDesc: 'Implementamos Sistemas de Gestión basados en Normas Nacionales e Internacionales, reconociendo que representan las mejores prácticas de cada industria a nivel global para lograr eficiencia organizacional.',
      features: [
        'Diagnóstico organizacional',
        'Diseño de sistemas de gestión',
        'Implementación ISO',
        'Documentación de procesos',
        'Auditorías internas'
      ],
      benefits: [
        'Eficiencia operacional',
        'Cumplimiento normativo',
        'Mejora continua',
        'Certificaciones internacionales'
      ],
      duration: '6-12 meses',
    },
    {
      id: 7,
      category: 'consulting',
      icon: '🎓',
      title: 'Capacitación',
      shortDesc: 'Entrenamiento especializado basado en transferencia de conocimientos.',
      fullDesc: 'Ofrecemos programas de capacitación especializados impartidos por personal calificado con años de experiencia, enfocados en diferentes normativas y basados en la efectiva transferencia de conocimientos.',
      features: [
        'Programas personalizados',
        'Instructores certificados',
        'Material didáctico actualizado',
        'Evaluación de competencias',
        'Certificaciones'
      ],
      benefits: [
        'Personal más competente',
        'Cumplimiento normativo',
        'Reducción de errores',
        'Mejora en productividad'
      ],
      duration: '1-3 meses',
    },
    {
      id: 8,
      category: 'consulting',
      icon: '🏆',
      title: 'Asesoría en Certificaciones',
      shortDesc: 'Proyectos llave en mano para certificaciones exitosas.',
      fullDesc: 'Nuestro personal experto te acompaña en todo el proceso para conseguir certificaciones exitosas a través de proyectos llave en mano, ya sea de forma individual o integrada según tus necesidades.',
      features: [
        'Análisis de requisitos',
        'Preparación de documentación',
        'Implementación de controles',
        'Auditorías de preparación',
        'Acompañamiento en certificación'
      ],
      benefits: [
        'Certificación garantizada',
        'Cumplimiento normativo',
        'Credibilidad empresarial',
        'Ventaja competitiva'
      ],
      duration: '3-9 meses',
    }
  ];

  // Categorías de servicios
  const categories = [
    { id: 'todos', label: 'Todos los Servicios', count: services.length },
    { id: 'tech', label: 'Tecnología', count: services.filter(s => s.category === 'tech').length },
    { id: 'consulting', label: 'Consultoría', count: services.filter(s => s.category === 'consulting').length }
  ];

  // Filtrar servicios por categoría
  const filteredServices = activeCategory === 'todos' 
    ? services 
    : services.filter(service => service.category === activeCategory);

  // Hook para animaciones
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in--visible');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.fade-in').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, [activeCategory]);

  // Función para manejar click en servicio
  const handleServiceClick = (service) => {
    setSelectedService(service);
  };

  // Función para cerrar modal
  const closeModal = () => {
    setSelectedService(null);
  };

  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="container">
          <div className="services-hero__content fade-in">
            <span className="services-hero__eyebrow">Lo que ofrecemos</span>
            <h1 className="services-hero__title">
              Nuestros <span className="services-hero__title-gradient">Servicios</span>
            </h1>
            <p className="services-hero__subtitle">
              Soluciones integrales de tecnología y consultoría con más de 20 años de experiencia
            </p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-main">
        <div className="container">
          {/* Category Filter */}
          <div className="services-filter fade-in">
            <h2 className="services-filter__title">Explora nuestros servicios</h2>
            <div className="services-filter__tabs">
              {categories.map(category => (
                <button
                  key={category.id}
                  className={`services-filter__tab ${activeCategory === category.id ? 'services-filter__tab--active' : ''}`}
                  onClick={() => setActiveCategory(category.id)}
                >
                  {category.label}
                  <span className="services-filter__count">({category.count})</span>
                </button>
              ))}
            </div>
          </div>

          {/* Services Grid */}
          <div className="services-grid">
            {filteredServices.map((service, index) => (
              <div 
                key={service.id} 
                className="service-card fade-in"
                style={{ animationDelay: `${index * 0.1}s` }}
                onClick={() => handleServiceClick(service)}
              >
                <div className="service-card__header">
                  <div className="service-card__icon">{service.icon}</div>
                  <div className="service-card__category">
                    {service.category === 'tech' ? 'Tecnología' : 'Consultoría'}
                  </div>
                </div>
                <h3 className="service-card__title">{service.title}</h3>
                <p className="service-card__description">{service.shortDesc}</p>
                <div className="service-card__footer">
                  <span className="service-card__price">{service.price}</span>
                  <button className="service-card__button">
                    Ver detalles →
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="services-cta">
        <div className="container">
          <div className="services-cta__content fade-in">
            <h2 className="services-cta__title">¿No encuentras lo que buscas?</h2>
            <p className="services-cta__subtitle">
              Contáctanos para desarrollar una solución personalizada para tu empresa
            </p>
            <button 
              className="btn btn--primary btn--large"
              onClick={() => {
                navigate('/contacto');
                setTimeout(() => {
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }, 100);
              }}
            >
              Contactar Ahora
            </button>
          </div>
        </div>
      </section>

      {/* Service Detail Modal */}
      {selectedService && (
        <div className="service-modal" onClick={closeModal}>
          <div className="service-modal__content" onClick={(e) => e.stopPropagation()}>
            <button className="service-modal__close" onClick={closeModal}>
              ✕
            </button>
            
            <div className="service-modal__header">
              <div className="service-modal__icon">{selectedService.icon}</div>
              <div>
                <h2 className="service-modal__title">{selectedService.title}</h2>
                <span className="service-modal__category">
                  {selectedService.category === 'tech' ? 'Tecnología' : 'Consultoría'}
                </span>
              </div>
            </div>

            <div className="service-modal__body">
              <p className="service-modal__description">{selectedService.fullDesc}</p>
              
              <div className="service-modal__details">
                <div className="service-modal__section">
                  <h4>¿Qué incluye?</h4>
                  <ul>
                    {selectedService.features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                </div>

                <div className="service-modal__section">
                  <h4>Beneficios</h4>
                  <ul>
                    {selectedService.benefits.map((benefit, index) => (
                      <li key={index}>{benefit}</li>
                    ))}
                  </ul>
                </div>

                <div className="service-modal__info">
                  <div className="service-modal__info-item">
                    <span className="service-modal__info-label">Duración:</span>
                    <span className="service-modal__info-value">{selectedService.duration}</span>
                  </div>
                  <div className="service-modal__info-item">
                    <span className="service-modal__info-value">{selectedService.price}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="service-modal__footer">
              <button className="btn btn--secondary" onClick={closeModal}>
                Cerrar
              </button>
              <button 
                className="btn btn--primary"
                onClick={() => {
                  navigate('/contacto?service=' + encodeURIComponent(selectedService.title));
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }, 100);
                }}
              >
                Solicitar Cotización
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Services;